module.exports = __webpack_public_path__ + "static/media/add-icon-v2.22c87690.svg";